import s from '../allservices.jsx'
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js'

export const transferHistory = (actionCallback, id, startDate, endDate, status) => {
    let token = "Token " + localStorage.getItem('token')
    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    const state = {
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
        cardDetailsId: id,
        historyType: "P",
        statementFromDate: startDate || "",
        statementTodDate: endDate || "",
        status: status
    }
    let traceId = getClientId();
    fetch(plink + s.get_transactionid, {
        method: "POST",
        headers: {
            'content-type': 'application/json',
            'Authorization': token,
             'X-Trace-Id': traceId,
             'X-KlickEx-Client':buildClientHeader(),
        },
        body: JSON.stringify(state)
    })
        .then(res => {
            if (res.status === 200 || res.status === 201) {
                res.json().then(json => actionCallback(json, "success", res.status))
            } else if (res.status === 204) {
                actionCallback({ "transactions": [] }, "success", res.status)
            } else {
                actionCallback([], res.headers.get('message'), res.status)
            }
        })
}


// WEBPACK FOOTER //
// ./src/services/components/transfer_history.jsx